import asyncComponent from '../../../components/AsyncComponent';

const ClauseVariantPage = asyncComponent(() => import('../../../containers/Clause/Variant'));

export default ClauseVariantPage;
